export const categorias = {
    indicador: "Indicadores",
    execucao: "Execução",

}